import React from "react";

const experience = [
  {
    title: "Simulation Engineer",
    company: "Purdue Envision Center",
    dates: "2019 — 2025",
    description:
      "Developed simulation and visualization applications across virtual reality, desktop, mobile, and web platforms.",
    technologies: ["C#", "Unity", "Python", "JavaScript", "VR"],
  },
  {
    title: "Teaching Assistant",
    company: "Purdue University",
    dates: "2022 — 2024",
    description:
      "Taught and developed course material in game design, project management, professional development, and web design.",
    technologies: ["Game Design", "Web", "Project Management", "Teaching"],
  },
  {
    title: "Research Assistant",
    company: "Purdue University",
    dates: "2019",
    description:
      "Conducted research on locomotion behavior and interaction techniques in virtual reality.",
    technologies: ["VR", "Unity", "C#", "Python"],
  },
  {
    title: "Application Developer → Developer",
    company: "Urban Science",
    dates: "2015 — 2019",
    description:
      "Developed web and mobile applications, automated testing and deployment workflows, mentored interns, and advised MSU Capstone teams on proof-of-concept applications.",
    technologies: ["C#", "Angular", "ASP.NET", "MSSQL", "Cordova"],
  },
];

const earlierExperience = [
  {
    title: "Project Manager",
    company: "Cube2Cube",
    dates: "2014 — 2015",
  },
  {
    title: "Web Developer",
    company: "Global Observatory for Ecosystem Services",
    dates: "2014",
  },
  {
    title: "Website Administrator",
    company: "MSU Engineering Career Center",
    dates: "2013 — 2014",
  },
  {
    title: "Intern",
    company: "The Baldwin Center",
    dates: "2012",
  },
];

export const Timeline = () => {
  return (
    <section className="experience" id="jobs">
      <div className="container">
        <header className="experience-header">
          <span className="section-label">EXPERIENCE</span>

          <h2>Work Experience</h2>

          <p>
            Professional experience spanning simulation, virtual reality,
            software development, research, and teaching.
          </p>
        </header>

        <div className="experience-list">
          {experience.map((job) => (
            <article
              className="experience-item"
              key={`${job.company}-${job.title}`}
            >
              <div className="experience-date">{job.dates}</div>

              <div className="experience-content">
                <div className="experience-title-row">
                  <div>
                    <h3>{job.title}</h3>
                    <div className="experience-company">{job.company}</div>
                  </div>
                </div>

                <p>{job.description}</p>

                <div className="experience-tags">
                  {job.technologies.map((technology) => (
                    <span key={technology}>{technology}</span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="earlier-experience">
          <div className="earlier-experience-heading">
            <span>EARLIER EXPERIENCE</span>
            <div />
          </div>

          <div className="earlier-experience-grid">
            {earlierExperience.map((job) => (
              <div
                className="earlier-experience-item"
                key={`${job.company}-${job.title}`}
              >
                <span className="earlier-experience-date">{job.dates}</span>

                <div>
                  <h3>{job.title}</h3>
                  <p>{job.company}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
